<template>
  <b-container>
    <div class="subject py-3">
      <h1 class="subject__title">{{ subject.name }}</h1>
      <template v-for="part in subject.parts">
        <div :key="part.id" class="subject__part">
          <b-row no-gutters>
            <b-col md="4" cols="12" class="subject__part__header">
              <div class="subject__part__line"><strong>{{ part.name }}</strong></div>
            </b-col>
            <b-col md="3" class="subject__part__header d-none d-md-block">
              <div class="subject__part__line text-center">Nắm vững</div>
            </b-col>
            <b-col md="2" class="subject__part__header d-none d-md-block">
              <div class="subject__part__line text-center">Câu đúng/Tổng</div>
            </b-col>
            <b-col md="3" class="subject__part__header d-none d-md-block">
              <div class="subject__part__line text-center"></div>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col md="4" class="d-none d-md-block">
              <div class="subject__part__line">{{ part.description }}</div>
            </b-col>
            <b-col md="3" cols="4">
              <div class="subject__part__line text-center">
                <span class="percent">
                  <span class="percent__current" :style="'width: ' + (part.total.correct / part.total.question * 100).toFixed(2) + '%'"></span>
                </span>
                <span>{{ (part.total.correct / part.total.question * 100).toFixed(2) }}%</span>
              </div>
            </b-col>
            <b-col md="2" cols="3">
              <div class="subject__part__line text-center">
                {{ part.total.correct }}/{{ part.total.question }}
                <div class="d-md-none">(Đúng/Tổng)</div>
              </div>
            </b-col>
            <b-col md="3" cols="5">
              <div class="subject__part__line text-center">
                <template v-if="part.free">
                  <b-link
                    :to="{
                      name: 'class-subject-part',
                      params: { id: part.id, slug: part.slug }
                    }"
                    :title="part.name"
                    class="subject__part__btn"
                    >Luyện tập đơn</b-link>
                </template>
                <template v-else>
                  <b-button
                    class="subject__part__btn btn-block"
                    disabled
                    >Luyện tập đơn</b-button>
                </template>
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { STORE_KEY } from '../_store/constants'
import { APP_CONFIG } from '@/utils/constants'
import moment from 'moment'

export default {
  name: 'ClassSubjectDetail',
  data() {
    return {
      id: this.$route.params.id,
      slug: this.$route.params.slug,
      cdnUrl: APP_CONFIG.cdnUrl
    }
  },
  metaInfo () {
    return {
      title: 'Lớp ôn tập'
    }
  },
  computed: {
    ...mapGetters({
      subject: `${STORE_KEY}/subject`
    })
  },
  beforeMount() {
    this.getSubjectDetail(this.id);
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ['getSubjectDetail']),
    parseUTCDate(ts) {
      return moment.unix(ts)
    }
  }
};
</script>